import {
  AlignCenterVertically,
  AlignCenterVerticallySmall,
  AlignLeft,
  AlignLeftSmall,
  AlignRight,
  AlignRightSmall
} from "@wix/wix-ui-icons-common";
import {
  ALIGNMENT_DROPDOWN_OPTION_CENTER,
  ALIGNMENT_DROPDOWN_OPTION_LEFT,
  ALIGNMENT_DROPDOWN_OPTION_RIGHT,
  ALIGNMENT_DROPDOWN_OPTION_TEXT_WRAP
} from "./../data-hooks.js";
const NODE_ALIGNMENT_BUTTONS = {
  LEFT: {
    type: "button",
    text: "AlignObject_Left_Tooltip",
    tooltip: "AlignObject_Left_Tooltip",
    commandKey: "LEFT",
    icon: AlignLeft,
    iconSmall: AlignLeftSmall,
    wixelIcon: AlignLeft,
    dataHook: ALIGNMENT_DROPDOWN_OPTION_LEFT
  },
  CENTER: {
    type: "button",
    text: "AlignObject_Center_Tooltip",
    tooltip: "AlignObject_Center_Tooltip",
    commandKey: "CENTER",
    icon: AlignCenterVertically,
    iconSmall: AlignCenterVerticallySmall,
    wixelIcon: AlignCenterVertically,
    dataHook: ALIGNMENT_DROPDOWN_OPTION_CENTER
  },
  RIGHT: {
    type: "button",
    text: "AlignObject_Right_Tooltip",
    tooltip: "AlignObject_Right_Tooltip",
    commandKey: "RIGHT",
    icon: AlignRight,
    iconSmall: AlignRightSmall,
    wixelIcon: AlignRight,
    dataHook: ALIGNMENT_DROPDOWN_OPTION_RIGHT
  }
};
const TEXT_WRAP_TOGGLE = {
  type: "toggle",
  text: "TextwrapObject_ToggleButton",
  infoIconTextUnsupportedContainer: "TextwrapObject_ToggleButton_Info_UnsupportedContainer",
  infoIconTextAlignedCenter: "TextwrapObject_ToggleButton_Info_AlignedCenter",
  commandKey: "TEXT_WRAP",
  dataHook: ALIGNMENT_DROPDOWN_OPTION_TEXT_WRAP
};
const DEFAULT_OPTIONS = ["LEFT", "CENTER", "RIGHT"];
export {
  DEFAULT_OPTIONS,
  NODE_ALIGNMENT_BUTTONS,
  TEXT_WRAP_TOGGLE
};
//# sourceMappingURL=consts.js.map
